import { IconButton } from "@mui/material";
import { ZoomIn, ZoomOut } from "@mui/icons-material";
import { Vocabulary } from "../../Utils/Vocabulary";
import styles from "../../Styles/previewPDF.module.css";
import { ZoomControlsProps } from "../../Utils/Types";

function ZoomControls({
  scale,
  minScale,
  maxScale,
  onZoomIn,
  onZoomOut,
}: ZoomControlsProps) {
  return (
    <div className={styles.zoomControls}>
      <IconButton
        className={styles.zoomButton}
        size="large"
        disabled={scale >= maxScale}
        onClick={onZoomIn}
        aria-label={Vocabulary.zoomIn}
      >
        <ZoomIn />
      </IconButton>
      <IconButton
        className={styles.zoomButton}
        size="large"
        disabled={scale <= minScale}
        onClick={onZoomOut}
        aria-label={Vocabulary.zoomOut}
      >
        <ZoomOut />
      </IconButton>
    </div>
  );
}

export default ZoomControls;
